export default function TypeIcon() {
  return (
    <svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.06663 3.9418C9.02314 3.925 8.97496 3.925 8.93148 3.9418L2.7625 6.32527C2.6026 6.38705 2.6026 6.61329 2.7625 6.67507L8.93148 9.05853C8.97496 9.07533 9.02314 9.07533 9.06663 9.05853L15.2356 6.67507C15.3955 6.61329 15.3955 6.38705 15.2356 6.32527L9.06663 3.9418ZM8.52603 2.8924C8.83041 2.7748 9.16769 2.7748 9.47208 2.8924L15.6411 5.27587C16.7604 5.70833 16.7604 7.29201 15.6411 7.72446L9.47208 10.1079C9.16769 10.2255 8.83041 10.2255 8.52603 10.1079L2.35705 7.72446C1.23775 7.29201 1.23775 5.70833 2.35705 5.27587L8.52603 2.8924Z'
        fill='currentColor'
      />
      <path
        d='M15.6411 10.7245L9.47208 13.1079C9.16769 13.2255 8.83041 13.2255 8.52603 13.1079L2.35705 10.7245C1.69003 10.4668 1.42051 9.80021 1.54848 9.2121L8.89977 12.0524C8.9279 12.0632 8.95734 12.0694 8.98696 12.0707C8.99372 12.0712 9.0005 12.0713 9.00726 12.071C9.03879 12.0701 9.07022 12.0639 9.10014 12.0524L16.4498 9.21274C16.5774 9.80069 16.3078 10.4668 15.6411 10.7245Z'
        fill='currentColor'
      />
      <path
        d='M15.6416 13.7244L9.4726 16.1079C9.16821 16.2255 8.83093 16.2255 8.52655 16.1079L2.35757 13.7244C1.69055 13.4667 1.42102 12.8002 1.549 12.2121L8.90029 15.0523C8.92841 15.0632 8.95786 15.0693 8.98748 15.0707C8.99424 15.0711 9.00101 15.0712 9.00778 15.0709C9.03931 15.0701 9.07074 15.0639 9.10066 15.0523L16.4503 12.2127C16.5779 12.8006 16.3083 13.4668 15.6416 13.7244Z'
        fill='currentColor'
      />
    </svg>
  )
}
